import KBStatus from "@/models/KnowledgeBase/KBStatus";
import KBVisibility from "@/models/KnowledgeBase/KBVisibility";

// Search Types
export const SEARCH_TYPE_TEXT = 'text';
export const SEARCH_TYPE_SEMANTIC = 'semantic';

// Status badge colors
export const STATUS_COLORS = {
  [KBStatus.Draft]: 'orange',
  [KBStatus.Published]: 'green',
  [KBStatus.Archived]: 'grey'
};

// Visibility badge colors
export const VISIBILITY_COLORS = {
  [KBVisibility.Internal]: 'red',
  [KBVisibility.External]: 'blue'
};
